import { REWARDS } from './constants'
import type { Inventory, RelicRewardId, RewardFamily } from './types'

export interface RelicSynergyDefinition {
  id: 'motor-biometrico' | 'recuperacion-integral' | 'ritual-de-racha'
  name: string
  family: RewardFamily
  relics: readonly RelicRewardId[]
  description: string
}

export const RELIC_SYNERGIES: readonly RelicSynergyDefinition[] = [
  {
    id: 'motor-biometrico',
    name: 'Motor biométrico',
    family: 'Resistencia',
    relics: ['botas-ligeras', 'pulsera-biometrica'],
    description: 'Botas ligeras reducen el coste y facilitan que Pulsera biométrica mantenga su bonus de OVR.',
  },
  {
    id: 'recuperacion-integral',
    name: 'Recuperación integral',
    family: 'Recuperación',
    relics: ['camilla-portatil', 'lider-silencioso'],
    description: 'Camilla portátil aumenta la recuperación y Líder silencioso convierte parte de ese físico en moral.',
  },
  {
    id: 'ritual-de-racha',
    name: 'Ritual de racha',
    family: 'Racha',
    relics: ['recorte-periodico', 'ritual-vestuario'],
    description: 'Recorte de periódico aumenta el OVR con la racha y Ritual del vestuario ayuda a sostenerla recuperando físico.',
  },
]

export function getActiveRelicSynergies(inventory: Inventory): RelicSynergyDefinition[] {
  return RELIC_SYNERGIES.filter((synergy) => synergy.relics.every((relicId) =>
    REWARDS[relicId].kind === 'relic' && (inventory[relicId]?.count ?? 0) > 0,
  ))
}

export function relicSynergyRecipe(synergy: RelicSynergyDefinition): string {
  return synergy.relics.map((relicId) => REWARDS[relicId].name).join(' + ')
}
